import script from "./VModalError.vue?vue&type=script&setup=true&lang=ts"
export * from "./VModalError.vue?vue&type=script&setup=true&lang=ts"

import "./VModalError.vue?vue&type=style&index=0&id=470c5a14&lang=scss"

const __exports__ = script;

export default __exports__